import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 100%;
  flex: 1;
  display: flex;
  gap: 1rem;
  flex-direction: column;

  padding: 0 5px 0 5px;
  background-color: white;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const CardsWrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-self: stretch;
  align-items: flex-start;
  gap: 1rem;

  padding: 0;
  background-color: white;
`;

export const Linha1 = styled.div`
  flex: 1;
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  justify-content: flex-start;
  align-items: flex-start;
  align-self: stretch;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Linha2 = styled.div`
  height: 350px;
  max-height: 350px;
  flex: 1;
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 3fr 1fr 1fr;
  justify-content: flex-start;
  align-items: flex-start;
  align-self: stretch;
  gap: 1rem;

  @media (max-width: 768px) {
    max-height: 5000px;
    grid-template-columns: 1fr;
  }
`;
